import {
    AddinViewState,
    LastFocusedControl,
} from 'owa-editor-addin-plugin-types/lib/utils/AddinViewState';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'updateLastFocusedControl',
    (viewState: AddinViewState, control: LastFocusedControl) => {
        viewState.lastFocusedControl = control;
    }
);
